export const domains = [
  {
    en: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    'en-gb': {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    de: {
      localhost: 'localhost:3000/de',
      dlr: 'https://dlr-frontend.getdeveloper.net/de',
      uat: 'https://uat.digitalrealty.com/de',
      production: 'https://www.digitalrealty.com/de',
    },
  },
  {
    fr: {
      localhost: 'localhost:3000/fr',
      dlr: 'https://dlr-frontend.getdeveloper.net/fr',
      uat: 'https://uat.digitalrealty.com/fr',
      production: 'https://www.digitalrealty.com/fr',
    },
  },
  {
    nl: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    ko: {
      localhost: 'localhost:3000/ko',
      dlr: 'https://dlr-frontend.getdeveloper.net/ko',
      uat: 'https://uat.digitalrealty.com/ko',
      production: 'https://www.digitalrealty.com/ko',
    },
  },
  {
    'zh-hans': {
      localhost: 'localhost:3000/zh',
      dlr: 'https://dlr-frontend.getdeveloper.net/zh',
      uat: 'https://uat.digitalrealty.com/zh',
      production: 'https://www.digitalrealty.com/zh',
    },
  },
  {
    ja: { //not in use
      localhost: 'localhost:3000',
      dlr: 'https://dlr-jp.getdeveloper.net',
      uat: 'https://uat-jp.digitalrealty.com',
      production: 'https://www.digitalrealty.jp',
    },
  },
  {
    es: {
      localhost: 'localhost:3000/es',
      dlr: 'https://dlr-frontend.getdeveloper.net/es',
      uat: 'https://uat.digitalrealty.com/es',
      production: 'https://www.digitalrealty.com/es',
    },
  },
  {
    asia: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    at: {
      localhost: 'localhost:3000/de',
      dlr: 'https://dlr-frontend.getdeveloper.net/de',
      uat: 'https://uat.digitalrealty.com/de',
      production: 'https://www.digitalrealty.com/de',
    },
  },
  {
    ch: {
      localhost: 'localhost:3000/de',
      dlr: 'https://dlr-frontend.getdeveloper.net/de',
      uat: 'https://uat.digitalrealty.com/de',
      production: 'https://www.digitalrealty.com/de',
    },
  },
  {
    se: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    dk: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    ie: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    hr: { //not in use
      localhost: 'localhost:3000',
      dlr: 'https://dlr-hr.getdeveloper.net',
      uat: 'https://uat-hr.digitalrealty.com',
      production: 'https://digitalrealty.hr',
    },
  },
  {
    be: {
      localhost: 'localhost:3000',
      dlr: 'https://dlr-frontend.getdeveloper.net',
      uat: 'https://uat.digitalrealty.com',
      production: 'https://www.digitalrealty.com',
    },
  },
  {
    el: { //not in use
      localhost: 'localhost:3000',
      dlr: 'https://dlr-gr.getdeveloper.net',
      uat: 'https://uat-gr.digitalrealty.com',
      production: 'https://digitalrealty.gr',
    },
  },
];
